import script from "./RuleEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./RuleEditor.vue?vue&type=script&setup=true&lang=js"

import "./RuleEditor.vue?vue&type=style&index=0&id=067d7193&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-067d7193"]])

export default __exports__